<template>
  <slot v-if="isNotLoggedIn" />
</template>

<script>
import store from "../store";

export default {
  store,
  name: "IfNotConnected",

  computed: {
    isNotLoggedIn: function() {
      return !this.$store.getters["auth/isLoggedIn"];
    }
  }
};
</script>
